import React, { useEffect, useState, useRef } from 'react'
import { API } from '../../config/api'
import { ApiHelper } from '../../helpers/ApiHelper';
import '../../assets/css/inbox.css'
import '../../assets/css/style.css'
import "../../assets/css/responsive.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import { useParams } from 'react-router';
import Logo from '../../assets/images/TKC-Logo1.png'
import LogoPw from '../../assets/images/Logo.png'
import Spinner from '../../components/Spinner';
import frame from "../../assets/images/Frame-green.svg";

function ThankYou() {
  const params = useParams()
  const [loader, setLoader] = useState(false);
  const [companyLogo, setCompanyLogo] = useState('');
  useEffect(() => {
    getCandidateData()
  }, [])
  async function getCandidateData() {
    setLoader(true)
    const obj = {
      intervieweeid: params.id
    }
    await ApiHelper.post(API.getApplicantsbyId, obj)
      .then((resData) => {

        if (resData.data.success === true) {
          setCompanyLogo(resData?.data?.companyLogo)
          setLoader(false)
        }
        else {
          setLoader(false)
        }
      }).catch((err) => {
        console.log(err);
        setLoader(false)
      })
  }
  return (
        <div >
    
      <div className='fixHeader candPrv'>
        <div className='row'>
          <div className='w-100 logo-sec'>
            <div className='logoCent logo-sec'>
              {companyLogo !== null && <img src={API.avenuView + companyLogo} alt="logo" className="logo-inner mb-0 me-2" />}
            </div>
            <div className='logoSide logo-sec'>
              <p className='Powered-by-text'>Powered by</p>
              <img src={LogoPw} alt="copy" className="logo-inner mb-0 me-2" />
            </div>
          </div>
        </div>
      </div>

      <div className="thanku-cards has-text-centered is-wide ">
        <div className='card-1'>
          <h4 class="thanku-text">
            <img src={frame} alt="copy" className="create-icon mb-0 me-2" /> Thank you!
          </h4>
          <p className='thanku-sub-heading'>We have received your onboarding paperwork and your employer will get back to you soon.
            In the meanwhile, if you have any questions please contact your employer.</p>
          {/*<div className='text-center'>
            <button type='button' className='thank-close-button ' >close</button>
          </div>*/}
        </div>


      </div>

      {loader && <Spinner />}
    </div>
  )
}

export default ThankYou